import Vue from 'vue'
import Vuex from 'vuex'
import Oidc from './modules/oidc'
import Schedule from './modules/schedule'
import Notification from "./modules/notification";
import Profile from './modules/profile'

Vue.use(Vuex)
Vue.config.devtools = true
const store = new Vuex.Store({
    modules: {
        Oidc,
        schedule:Schedule,
        profile:Profile,
        notification:Notification
    }
})
export default store
